// Configuration de l'application
// URL de base du serveur (sans /api/v1)
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8000';

export const config = {
  // API Backend
  // URL de base du serveur (sans /api/v1)
  apiBaseUrl: API_BASE_URL,
  // URL complète de l'API (avec /api/v1)
  apiUrl: `${API_BASE_URL}/api/v1`,

  // Application
  appName: 'Dy\'kass',
  appVersion: '1.0.0',

  // Paiements
  currency: 'FCFA',
  currencySymbol: 'FCFA',
  taxRate: 0.18, // 18% TVA
  defaultShippingCost: 500,

  // Images
  imageBaseUrl: API_BASE_URL,
  placeholderImage: '/images/leaves-right.png',

  // Pagination
  productsPerPage: 12,
  ordersPerPage: 10,

  // Stock
  lowStockThreshold: 10,
  outOfStockThreshold: 0,

  // Méthodes de paiement disponibles
  paymentMethods: [
    { value: 'cash_on_delivery', label: 'Paiement en espèces à la livraison', icon: '💵' },
    { value: 'mobile_money', label: 'Mobile Money (Orange, MTN, Moov)', icon: '📱' },
    { value: 'bank_transfer', label: 'Virement bancaire', icon: '🏦' },
    { value: 'card', label: 'Carte bancaire', icon: '💳' },
  ],

  // Statuts de commande
  orderStatuses: {
    pending: { label: 'En attente', color: '#ffc107' },
    processing: { label: 'En traitement', color: '#2196F3' },
    completed: { label: 'Terminée', color: '#4CAF50' },
    cancelled: { label: 'Annulée', color: '#f44336' },
    delivered: { label: 'Livrée', color: '#4CAF50' },
  },

  // Rôles utilisateur
  userTypes: {
    customer: 'Client',
    supplier: 'Fournisseur',
    admin: 'Administrateur',
    delivery_person: 'Livreur',
  },

  // Régions (Gabon)
  regions: [
    'Libreville',
    'Port-Gentil',
    'Franceville',
    'Oyem',
    'Makokou',
  ],

  // Support
  supportEmail: 'bbndiade@gmail.com',
  supportPhone: '+241 06 78 07 73',

  // Social Media (à configurer)
  socialMedia: {
    facebook: '#',
    twitter: '#',
    instagram: '#',
    whatsapp: 'https://wa.me/24106780773',
  },
};

export default config;

